import { CURRENCIES_DECIMAL_PLACES } from "@/app/common/consts/currencies";

export default function currencyRounding(
  value: number,
  currencyCode: string
): number {
  const rounded = CURRENCIES_DECIMAL_PLACES[currencyCode?.toUpperCase()] ?? 2;
  return Number(
    Math.round(value * Math.pow(10, rounded)) / Math.pow(10, rounded)
  );
}
